module.exports = __webpack_public_path__ + "img/office-3.5efb3989.webp";